/*
 * Copyright © 2017 TEKTELIC Communications Inc.
 */
/* eslint-disable import/no-unresolved, import/default */

import entityTableTemplate from '../table/entity-table.tpl.html';
import customerDetailsTemplate from './customer-details.tpl.html';

/* eslint-enable import/no-unresolved, import/default */

/*@ngInject*/
export default function CustomerRoutes($stateProvider, $injector) {

    var types = $injector.get('types');

    $stateProvider
        .state('home.customers', {
            url: '/customers',
            module: 'private',
            auth: [types.authority.PROVIDER_ADMIN.value, types.authority.PROVIDER_USER.value],
            views: {
                "content@home": {
                    templateUrl: entityTableTemplate,
                    controllerAs: 'vm',
                    controller: 'EntityTableController'
                }
            },
            data: {
                searchEnabled: false,
                pageTitle: 'customer.customers'
            },
            ncyBreadcrumb: {
                label: '{"icon": "supervisor_account", "label": "customer.customers"}'
            },
            resolve: {
                entityTableConfiguration:
                /*@ngInject*/
                    function($stateParams, customerTableConfig) {
                        return customerTableConfig.getConfig($stateParams);
                    }
            }
        })
        .state('home.customer', {
            url: '/customer',
            module: 'private',
            auth: [types.authority.CUSTOMER_ADMIN.value, types.authority.CUSTOMER_USER.value],
            views: {
                "content@home": {
                    templateUrl: customerDetailsTemplate,
                    controllerAs: 'vm',
                    controller: 'CustomerDetailsController'
                }
            },
            data: {
                pageTitle: 'customer.customer'
            },
            ncyBreadcrumb: {
                label: '{"icon": "supervisor_account", "label": "customer.customer"}'
            }
        });
}



// WEBPACK FOOTER //
// ./src/app/customer/customer.routes.js